// The Vue build version to load with the `import` command
// (runtime-only or standalone) has been set in webpack.base.conf with an alias.
import Vue from 'vue'
import App from './App'
import router from './router'
import ElementUI from 'element-ui';
import "@/assets/style/common.css";
import 'element-ui/lib/theme-chalk/index.css';


// import { axios_get, axios_post, axios_put, axios_delete, axios_DownloadFile, export_get, export_post } from "@/api/api"
// Vue.prototype.axios_get = axios_get
// Vue.prototype.axios_post = axios_post
// Vue.prototype.axios_put = axios_put
// Vue.prototype.axios_delete = axios_delete
// Vue.prototype.axios_DownloadFile = axios_DownloadFile

Vue.use(ElementUI);
Vue.config.productionTip = false
// Vue.config.preload = preload(imgArr) {
//   let pa = [];
//   imgArr.forEach((n) => {
//     pa.push(
//       new Promise(async (resolve, reject) => {
//         let myImage = new Image();
//         myImage.src = n;
//         myImage.onload = function () {
//           resolve();
//         };
//         myImage.onerror = function () {
//           resolve();
//         };
//       })
//     );
//   });
//   return Promise.all(pa);
// };
/* eslint-disable no-new */
new Vue({
  el: '#app',
  router,
  components: { App },
  template: '<App/>',
  mounted() {
    document.dispatchEvent(new Event('render-event'))
  }
})



// WEBPACK FOOTER //
// ./src/main.js